import React, { useState, Suspense } from 'react';
import CreateCourseSubmit from './CourseCreateSubmit';
import { FormContainer, FormBackground } from '../CreateForm.styles';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';

const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const PageScroller = React.lazy(
  () => import('../../../Components/PageScroller/PageScroller.component')
);
const ResultModal = React.lazy(
  () => import('../../../Components/Modal/ResultModal.component')
);
const CourseMainInputs = React.lazy(
  () => import('../../../Components/CourseForm/CourseMainInputs')
);
const CourseSecondaryInputs = React.lazy(
  () => import('../../../Components/CourseForm/CourseSecondaryInputs')
);
const CourseThirdInputs = React.lazy(
  () => import('../../../Components/CourseForm/CourseThirdInputs')
);

const CreateCourse = () => {
  const [course, setCourse] = useState({
    courseName: '',
    shortName: '',
    description: '',
    notes: '',
    price: 25,
    expiryDate: 0,
    certificatePrefix: '',
    active: false,
    partTwo: false,
  });
  const [tags, setTags] = useState([]);
  const [image, setImage] = useState('');
  const [questions, setQuestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [successState, setSuccessState] = useState('');
  const [pdf, setPdf] = useState(null);
  const [video, setVideo] = useState('');
  const [videoLinks, setVideoLinks] = useState([]);
  const [att, setAtt] = useState([]);

  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Create Course"
        description="Form for creating a course"
      />
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Admin Dashboard"
            oneLink="/admin"
            two="Create Course"
          />
        </Suspense>
        <h2>CREATE COURSE</h2>
        <form>
          <FormBackground>
            <Suspense fallback={<p>Loading main inputs...</p>}>
              <CourseMainInputs course={course} setCourse={setCourse} />
            </Suspense>
            <Suspense fallback={<p>Loading secondary inputs...</p>}>
              <CourseSecondaryInputs
                att={att}
                setAtt={setAtt}
                videoLinks={videoLinks}
                setVideoLinks={setVideoLinks}
                video={video}
                setVideo={setVideo}
                pdf={pdf}
                setPdf={setPdf}
                image={image}
                setImage={setImage}
              />
            </Suspense>
            <Suspense fallback={<p>Loading third inputs...</p>}>
              <CourseThirdInputs
                tags={tags}
                setTags={setTags}
                questions={questions}
                setQuestions={setQuestions}
              />
            </Suspense>
            <Suspense fallback={<p>Loading result modal...</p>}>
              <ResultModal
                isOpen={isOpen}
                result={successState}
                onClose={() => setIsOpen(false)}
                linkTo="/admin"
              />
            </Suspense>
            <Suspense fallback={<p>Loading page scroller...</p>}>
              <PageScroller />
            </Suspense>
          </FormBackground>
          <CreateCourseSubmit
            pdf={pdf}
            course={course}
            videoLinks={videoLinks}
            att={att}
            questions={questions}
            tags={tags}
            image={image}
            setIsOpen={setIsOpen}
            setSuccessState={setSuccessState}
            disabled={true}
            successState={successState}
          />
        </form>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default CreateCourse;
